import React from 'react';
import {Tag, Tooltip} from 'antd';

const TruncatedTag = ({text, color, onClick}: { text: string, color: string, onClick: () => void }) => {
    const max = 50;
    const truncated = text && text.length > max ? text.slice(0, max) + '...' : text;

    return (
        <Tooltip title={text}>
            <Tag
                onClick={onClick}
                color={color}
                style={{
                    marginTop: 12,
                    display: 'inline-block',
                    maxWidth: 400,         // не даёт тэгу расти слишком широко
                    whiteSpace: 'nowrap',  // одна строка
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    verticalAlign: 'middle',
                    cursor: 'pointer',
                }}
            >
                {truncated}
            </Tag>
        </Tooltip>
    );
};

export default TruncatedTag;
